import React from "react"
import "./SHeader.css"
import { TypeAnimation } from 'react-type-animation'

const SHeader = () => {
  return (
    <>
      <div className="squaremain-div">
        <div className="squareheader-top">
          <div className="squareheader">
            <div className="squareheader-content">
              <TypeAnimation
                className="squareheading"
                sequence={[
                  `THE SQUARE`,
                  10000
                ]}
                speed={350}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />

              {/* <h3>YOUR HOME IN THE PARK</h3> */}
              {/* <p>
              Residential Apartments Located in the Heart of Bahria Town, Lahore.
            </p> */}
              <TypeAnimation
                className="squaredes"
                sequence={[
                  `The Square by Avenue One is the flagship project of Avenue One Developments a premium high-rise, mixed-use project combining commercial spaces and residential apartments in one modern landmark.`,
                  20000
                ]}
                speed={150}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />
            </div>
          </div>
        </div>
        <div className="squareheadermobileview">
          <div className="squareheadermobileview-img">
            <img src="./SquarePhotos/Header/squareheader.webp" alt="building" />
          </div>
          <div className="squareheadermobileview-content">
            <TypeAnimation
              className="squaremobileviewheading"
              sequence={[
                `THE SQUARE`,
                20000
              ]}
              speed={200}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
            {/* <h3>YOUR HOME <br />IN THE PARK</h3> */}
            {/* <p>
            Residential Apartments Located In The Heart of Bahria Town, Lahore.
          </p> */}
            <TypeAnimation
              className="squaremobileviewdes"
              sequence={[
                `The Landmark is Rising`,
                20000
              ]}
              speed={150}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SHeader
